import { useMemo, useState } from 'react';

import { useWindowSize } from '../../hooks/useWindowSize';

import { UIContext } from './UIContext';

export const UIContextProvider = ({ children }) => {
  const device = useWindowSize();
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const context = useMemo(
    () => ({ device, mobileSidebarOpen, setMobileSidebarOpen }),
    [device, mobileSidebarOpen]
  );

  return <UIContext.Provider value={context}>{children}</UIContext.Provider>;
};
